"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WorkstreamType = void 0;
exports.WorkstreamType = {
  name: 'WorkstreamType',
  label: 'Activity Type',
  pluralLabel: 'Activity Types',
  type: 'taxonomy',
  autoRoutes: ['list', 'create', 'update']
};